import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiHome, FiArrowLeft, FiList, FiEdit3 } from 'react-icons/fi';

const GrampanchayatAsthapan = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { grampanchayatName, arthikVarshLabel } = location.state || {};

  const menuItems = [
    {
      title: "दाखले उतारे फी रिपोर्ट",
      icon: <FiList className="w-10 h-10" />,
      action: () => navigate('/asthapan/grampanchayat/fee-report', { state: location.state })
    },
    {
      title: "संज्ञा आणि संकेत",
      icon: <FiList className="w-10 h-10" />,
      action: () => navigate('/asthapan/grampanchayat/sangyna-aani-sanket', { state: location.state })
    },
    {
      title: "वार्ड माहिती",
      icon: <FiEdit3 className="w-10 h-10" />,
      action: () => navigate('/asthapan/grampanchayat/ward-mahiti', { state: location.state })
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6 md:p-8 font-poppins">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-10">
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 flex flex-col md:flex-row justify-between items-center bg-[#267c77] text-white">
          <div>
            <h1 className="text-3xl font-bold mb-2">ग्रामपंचायत</h1>
            <p className="text-white/80">
              {grampanchayatName || "ग्रामपंचायत"} | आर्थिक वर्ष: {arthikVarshLabel || "२०२४-२५"}
            </p>
          </div>
          <button 
            onClick={() => navigate('/asthapan-dashboard')}
            className="mt-4 md:mt-0 px-6 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors duration-200 text-sm font-medium backdrop-blur-sm flex items-center gap-2"
          >
            <FiArrowLeft />
            मागे जा
          </button>
        </div>
      </div>

      {/* Menu Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
        {menuItems.map((item, index) => (
          <div 
            key={index}
            onClick={item.action}
            className="bg-white rounded-xl shadow-md p-8 flex flex-col items-center justify-center text-center hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer border border-[#267c77]/20 group"
          >
            <div className="w-20 h-20 rounded-full bg-[#267c77]/10 flex items-center justify-center text-[#267c77] mb-4 group-hover:bg-[#267c77] group-hover:text-white transition-colors duration-300">
              {item.icon}
            </div>
            <h3 className="text-xl font-semibold text-gray-800 group-hover:text-[#267c77] transition-colors">
              {item.title}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GrampanchayatAsthapan;
